<div>
  <app-panel></app-panel>
  <div style="background-color: #F9F9F9; height: max-content;" >
  <div class="container">
    <div class="row">
      <div class="col-sm-6">
        <mat-card class="bocard">
          <mat-card-subtitle>{{'dmbr-bo.i18n.txt.toastr.contract.count' | translate}} </mat-card-subtitle>
          <mat-card-title style="font-size: large;"> {{countContract}}</mat-card-title>
          </mat-card>
      </div>
      <div class="col-sm-6">
        <mat-card class="bocard">
          <mat-card-subtitle>{{'dmbr-bo.i18n.txt.toastr.service.count' | translate}} </mat-card-subtitle>
          <mat-card-title  style="font-size: large;"> {{countService}}</mat-card-title>
      </mat-card>
      </div>
    </div>
     <div class="m-t-20"></div>
    <div class="row">
      <div class="col-sm-6">
        <mat-card class="bocard">
        <mat-card-subtitle>{{'dmbr-bo.i18n.label.app.log.dmbr' | translate}} </mat-card-subtitle>
        <mat-card-title  style="font-size: large;"> <a href="{{dmbrapplog}}" target="_blank"> {{'dmbr-bo.i18n.label.kibana.link' | translate}}</a></mat-card-title>
      </mat-card>
      </div>
      <div class="col-sm-6">
        <mat-card class="bocard">
        <mat-card-subtitle>{{'dmbr-bo.i18n.label.webservice.monitor.dmbr' | translate}} </mat-card-subtitle>
        <mat-card-title  style="font-size: large;"><a href="{{dmbrwsmtlog}}" target="_blank">{{'dmbr-bo.i18n.label.kibana.link' | translate}}</a></mat-card-title>
      </mat-card>
      </div>
    </div>
 <div class="m-t-20"></div>
    <div class="row">
      <div class="col-sm-6">
        <mat-card class="bocard">
        <mat-card-subtitle>{{'dmbr-bo.i18n.label.app.log.v360' | translate}} </mat-card-subtitle>
        <mat-card-title  style="font-size: large;"> <a href="{{v360applog}}" target="_blank">{{'dmbr-bo.i18n.label.kibana.link' | translate}}</a></mat-card-title>
        </mat-card>
      </div>
      <div class="col-sm-6">
        <mat-card class="bocard">
        <mat-card-subtitle>{{'dmbr-bo.i18n.label.webservice.monitor.v360' | translate}} </mat-card-subtitle>
        <mat-card-title  style="font-size: large;"> <a href="{{v360wsmtlog}}" target="_blank"> {{'dmbr-bo.i18n.label.kibana.link' | translate}}</a></mat-card-title>
      </mat-card>
      </div>
    </div>
  </div>
</div>
</div>